import React, { useCallback, useRef, useState } from 'react';
import Filter from '@/pages/dashboard/components/NewFilter';
import { setBtnPointLog } from '@/pages/dashboard/utils/utils';
import { formatDateFromFilterValue } from '@/pages/dashboard/utils/formatDate';
import { FORM_MAP } from '@/pages/dashboard/utils/_config/constant';
import { renderChurnLevel } from './filterList';
import { useSelector } from 'umi';
import { ROUTER_PATH, nightingaleChurnDefaultSelector } from './_config';
import { useFilterData } from './hooks';
import { getDateDefault } from '@/pages/dashboard/utils/dateUtils';

/**
 *
 * @param props
 * @param props:filterConfirm 筛选器确认函数
 * @param props:filterReset 筛选器重置函数
 * @param props:setFilterLoading 筛选器loading设置，透传到筛选器组件内部，获取到筛选器列表时区等数据之后，设置为false，测试才可进行页面和组件中的接口调用
 * @param props:filterInit 初始化函数，会向外部传递初始化后的筛选器值
 * @returns
 */

const ChurnNightingaleAllFilter = (props: any) => {
  const { filterConfirm, filterReset, filterInit, buttonLogConfig,path = ROUTER_PATH,  openSticky = false,
    isHaveFilterSave, children, timeZone = 0 } = props;
  // const timeDiff = useRef<boolean>(false);
  const filterValueRef = useRef<any>(null); // 筛选器值，此处不用state，更新formValue同样会触发组件更新
  const seasonInfo = useSelector((state: any) =>
    // 初始可能为undefied,在此加兜底
    state?.dashboardSetting?.gameConfig?.season_info || {date: [],week: [],month: []}
  );

  const {loading, selector} = useFilterData(ROUTER_PATH, nightingaleChurnDefaultSelector);

  // 设置inputList,和后端核对后，此次筛选器的展示都是由后端控制，配置为时间，地区，平台和语言四个筛选器
  const [inputList] = useState([
    {
      type: 'rangeDaily',
      key: 'rangeTime',
      default: getDateDefault({timeType: 'day', timeZone, startNum: 1, endNum: 1}),
      extraShortcut: seasonInfo
    },
    {
      type: "zone",
      key: "zone",
      isUseConfig: true,
      // visible: 0,
      default: [
        "255"
      ]
    },
    {
      type: 'region',
      key: "region",
      isUseConfig: true,
      // visible: 1,
      default: {
        markets: ['255'],
        region_type: 'market'
      },
    },
    {
      type: "channel",
      key: "channel",
      isUseConfig: true,
      // visible: 0,
      default: [
        "255"
      ]
    },
    {
      type: "system",
      key: "system",
      isUseConfig: true,
      // visible: 1,
      default: [
        "255"
      ],
      view_type: 'group'
    },
    {
      type: "lang",
      key: "lang",
      isUseConfig: true,
      // visible: 0,
      default: ["255"]
    },
    {
      key: 'churn_level',
      type: "churn_level",
      isUseConfig: true,
      // visible: 1,
      default: ['255'],
      render: renderChurnLevel
    },
  ]);

  // 私有化处理，抹平新旧筛选器的差距
  const onInit = useCallback((value, inputList,isHaveExtendFIlter) => {
    filterValueRef.current = value;
    filterInit({
      ...formatDateFromFilterValue(value, 'Day'),
      [FORM_MAP.RANGE_TIME_DIFF]: !isHaveExtendFIlter,
      pagePath: path
    });
  }, [filterInit]);

  const onConfirm = useCallback((value) => {
    filterValueRef.current = value;
    const obj: any = {
      ...formatDateFromFilterValue(value, 'Day'),
      [FORM_MAP.RANGE_TIME_DIFF]: false,
      pagePath: path
    };
    filterConfirm(obj);
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, obj);
  }, [filterConfirm]);

  const onReset = useCallback((value) => {
    filterValueRef.current = value;
    const obj = {
      ...formatDateFromFilterValue(value, 'Day'),
      [FORM_MAP.RANGE_TIME_DIFF]: true,
      pagePath: path
    };
    filterReset(obj);
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, obj, true);
  }, [filterReset]);

  return (
    <Filter
      config={props.config}
      openSticky={openSticky}
      isHaveFilterSave={isHaveFilterSave}
      loading={loading}
      outSelector={selector}
      path={path}
      pageDefaultSelector={nightingaleChurnDefaultSelector}
      value={filterValueRef.current}
      latestDateType={''}
      inputList={inputList}
      onInit={onInit}
      onConfirm={onConfirm}
      onReset={onReset}
    >
      {children}
    </Filter>
  );
};

export default ChurnNightingaleAllFilter;
